import { Types } from '@store/types';

const initialState = [];

const OrderTitleReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_ORDER_TITLE_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default OrderTitleReducer;
